module.exports = __webpack_public_path__ + "img/r.6ffb68cc.jpg";